export enum ContextType {
  USER = "user",
  TECH = "tech",
  GLOBAL = "global",
}
